import React from "react";

export default function HeaderNotice({ data }) {

    const arrow = <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5566 8.98535L10.0713 17.4707L8.65723 16.0566L13.0927 11.6212C13.7227 10.9912 13.2765 9.91406 12.3856 9.91406H0V7.91406H12.243C13.1339 7.91406 13.5801 6.83692 12.9501 6.20696L8.65723 1.91406L10.0713 0.5L18.5566 8.98535Z" fill="#A58FFF"/>
</svg>


    if (data.noticelink) {
        return (
            <a className="hq-header__notice" href={data.noticelink} target="_blank"> <div dangerouslySetInnerHTML={{ __html: data.notice }}></div>{arrow}</a>
        )
    } else {
        return (
            <div className="hq-header__notice" dangerouslySetInnerHTML={{ __html: data.notice }}></div>
        )
    }

}